<template>

<div class="logic" :class="{'is-first': isFirst}">

    <div v-tooltip="'Manage logic'" class="logic-type" v-on:click="onClick" v-click-outside="onOutsideClick">
    
        {{ text }}

    </div>

    <core-filter-advanced-builder-dropdown :options="options" v-on:change="onDropdownClick" v-if="expanded" />
	
</div>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

    props: ['logic', 'isFirst'],

    data: function() {

        return {
            expanded: false
        }

    },

    computed: {

        text: function() {

            return this.$_.findWhere(this.options, {
                value: this.logic
            }).text

        },

        options: function() {

            if (this.isFirst) {

                return [
                    { value: 'and', text: 'IS' },
                    { value: 'nand', text: 'IS NOT' }
                ]

            } else {

                return [
                    { value: 'and', text: 'AND' },
                    { value: 'nand', text: 'AND NOT' },
                    { value: 'or', text: 'OR' },
                    { value: 'nor', text: 'OR NOT' },
                ]

            }

        }

    },

    methods: {

        onDropdownClick: function(value) {

            this.$emit('change', value)
            
            this.expanded = false

        },

        onOutsideClick: function() {

            this.expanded = false

        },

        onClick: function() {

            this.expanded = !this.expanded

        }

    }

}

</script>

<style scoped>

.logic-type {
    margin: 0px auto;
    height: 20px;
    line-height: 20px;
    user-select: none;
    border-radius: 4px;
    color: #fff;
    font-weight: 700;
    font-size: 12px;
    margin: 0px auto;
    width: 64px;
    text-align: center;
    cursor: pointer;
    z-index: 1;
}

.logic:not(.is-first):after {
    content: '';
    display: block;
    position: absolute;
    top: -15px;
    bottom: -15px;
    left: 50%;
    margin-left: -1px;
    border: 1px dashed transparent;
    z-index: 0;
}

.logic.is-first:after {
    content: '';
    display: block;
    position: absolute;
    top: 0px;
    bottom: -15px;
    left: 50%;
    margin-left: -1px;
    border: 1px dashed transparent;
    z-index: 0;
}

.logic-type:hover {
    background-color: #082534!important;
}

</style>
